import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  styled,
  Dialog,
  ButtonGroup,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { getPizzaCrusts, getPizzaSizes } from "../apis/RangerOnlineApi";
import { DialogHeader } from "../components/DialogHeader";
import PizzaModifierSelector from "../components/PizzaModifierSelector";
import { getImageFolder } from "../Utils/utils";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiSelect-select": {
    height: "auto",
    minHeight: "1.4375em",
    textOverflow: "inherit !important",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  "& .MuiOutlinedInput-input": {
    [theme.breakpoints.up("sm")]: {
      fontSize: "14px !important",
    },
    [theme.breakpoints.up("xs")]: {
      fontSize: "12px !important",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "8px !important",
    },
  },
  "& .MuiCardHeader-subheader": {
    [theme.breakpoints.up("sm")]: {
      fontSize: "14px !important",
    },
    [theme.breakpoints.up("xs")]: {
      fontSize: "12px !important",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "8px !important",
    },
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, name, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {name}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
};

export const PizzaDialog = (props) => {
  const {
    open,
    product,
    onProductAdd,
    onClose,
    showLoader,
    closeLoader,
    defaultPizzaSizeId,
    settings,
  } = props;
  const [productCopy, setProductCopy] = useState({ ...product });
  const [pizzaSizeId, setPizzaSizeId] = useState("");
  const [crustTypeId, setCrustTypeId] = useState("");
  const [defaults, setDefaults] = useState({});
  const [customize, setCustomize] = useState(false);
  const [note, setNote] = useState("");
  const { DisplayDefaultCrustOnline, DefaultCrustName } = settings;

  const handleSizeChange = (e) => {
    const sizeId = e.target.value;
    let newDefaults = { ...defaults };
    const price = defaults.pizzaSizes.find(
      (x) => x.sizeId == sizeId
    ).sizePriceX1;
    let newProduct = { ...productCopy };
    newProduct.price = price;
    setProductCopy({ ...newProduct });
    setPizzaSizeId(sizeId);
    getPizzaCrusts(sizeId, 0, productCopy.productId).then((x) => {
      if (x?.status) {
        console.log(x.title);
      } else {
        //setCrustTypes(x);
        newDefaults.pizzaCrusts = x;
        setCrustTypeId(x[0]?.modifierId);
        setDefaults(newDefaults);
      }
    });
  };

  const handleCrustChange = (e) => {
    const crustId = e.target.value;
    const crust = defaults.pizzaCrusts.find((x) => x?.modifierId == crustId);
    setCrustTypeId(crustId);
  };

  const handleNumberCharge = (e) => {
    const id = e.target.id;
    const value = e.target.value;
    productCopy.quantity = value;
    setProductCopy({ ...productCopy });
  };

  const increaseCounter = () => {
    productCopy.quantity++;
    setProductCopy({ ...productCopy });
  };

  const decreaseCounter = () => {
    const newValue = productCopy.quantity || 0;
    const value = newValue - 1;
    if (value > 0) {
      /*const newPrice = pizzaSizes.find((x) => x.sizeId == pizzaSizeId)[
        `sizePriceX${value}`
      ];*/
      productCopy.quantity = value;
      setProductCopy({ ...productCopy });
    }
  };

  const handleCustomizationSave = (modifiers) => {
    let newProduct = { ...productCopy };
    const size = defaults.pizzaSizes.find((x) => x.sizeId == pizzaSizeId);
    const crust = defaults.pizzaCrusts.find(
      (x) => x?.modifierId == crustTypeId
    );
    newProduct.price = newProduct.price + crust?.modifierCost;
    newProduct.totalPrice = newProduct.price + modifiers.modifiersPrice;
    newProduct.modifiers = modifiers.subtitle;
    newProduct.fullDescription = `${newProduct.productName} [${size.sizeName}] CRUST - ${crust?.modifierName} ${modifiers.modifiers}`;
    newProduct.variationsPrice = modifiers.modifiersPrice;
    newProduct.toppings = modifiers.toppings.filter((x) => x.selected);

    setCustomize(false);
    handleAddToCart(newProduct);
  };

  const handleAddToCart = (newProduct) => {
    let product;
    if (newProduct) {
      if (newProduct.quantity <= 0) {
        alert("please select a valid quantity");
        return;
      }
      product = { ...newProduct };
      onProductAdd(product);
    } else {
      product = { ...productCopy };
      if (product.quantity <= 0) {
        alert("please select a valid quantity");
        return;
      }
      let fullDescription = `${product.productName}`;
      onClose();
      parseFloat(product.totalPrice.toFixed(2));
      product.variationsPrice = 0;

      const size = defaults.pizzaSizes.find((x) => x.sizeId == pizzaSizeId);
      const crust = defaults.pizzaCrusts.find(
        (x) => x?.modifierId == crustTypeId
      );
      product.price = product.price + crust?.modifierCost;
      product.totalPrice = product.price;

      fullDescription = `${fullDescription} \n [${size.sizeName}] CRUST - ${crust?.modifierName}`;
      if (note) fullDescription = fullDescription + ` \n **${note}`;
      Object.assign(product, { fullDescription: fullDescription });
    }

    onProductAdd(product);
  };

  useEffect(() => {
    showLoader();
    let newProduct = { ...productCopy };
    const getDefaults = async () => {
      const sizes = await getPizzaSizes(productCopy.productId);
      let crusts = [];
      if (sizes?.status) {
        console.log(sizes.title);
      } else {
        let price = sizes[0].sizePriceX1;
        const sizeId =
          defaultPizzaSizeId && defaultPizzaSizeId > 0
            ? defaultPizzaSizeId
            : sizes[0].sizeId;
        setPizzaSizeId(sizeId);
        crusts = await getPizzaCrusts(sizeId, 0, productCopy.productId);
        if (crusts.length > 0) {
          price = price + crusts[0]?.modifierCost;
          if (DisplayDefaultCrustOnline == 1) {
            const defaultCrustIndex = crusts.find((x) =>
              x?.modifierName
                .toLowerCase()
                .includes(DefaultCrustName.split(" ")[0].toLowerCase())
            )?.modifierId;
            setCrustTypeId(defaultCrustIndex);
          } else {
            setCrustTypeId(crusts[0]?.modifierId);
          }
        }
        newProduct.price = price;
      }
      let fullDescription = "";
      newProduct.defaultPizzaToppings.map(
        (modifier, index) =>
          (fullDescription =
            fullDescription +
            `${index > 0 ? ", " : "\n"}${modifier?.modifierName}`)
      );
      newProduct.modifiers = newProduct.productDescription;
      setProductCopy(newProduct);
      closeLoader();
      setDefaults({ pizzaSizes: sizes, pizzaCrusts: crusts });
    };

    getDefaults();
  }, []);

  return (
    <BootstrapDialog
      keepMounted={false}
      aria-labelledby="Pizza selection dialog"
      open={open}
      maxWidth="sm"
      fullWidth={true}
    >
      {open ? (
        <>
          <DialogTitle sx={{ padding: "0px" }}>
            <Box
              sx={{ display: "flex", justifyContent: "center", width: "100%" }}
            >
              <picture>
                {/* <source
                  media="(min-width: 1025px)"
                  srcSet="/images/lg_Pizza.jpg"
                /> */}
                <source
                  media="(min-width: 769px)"
                  srcSet={`${getImageFolder()}/images/md_${product.imageUrl}`}
                />
                <source
                  media="(min-width: 481px)"
                  srcSet={`${getImageFolder()}/images/sm_${product.imageUrl}`}
                />
                <source
                  media="(min-width: 0px)"
                  srcSet={`${getImageFolder()}/images/xs_${product.imageUrl}`}
                />
                <img
                  src={`${getImageFolder()}/images/no-image-icon-6.png`}
                  alt="No image found."
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.style.display = "none";
                  }}
                />
              </picture>
            </Box>
          </DialogTitle>
          <DialogContent dividers sx={{ padding: "0px 10px 10px 10px" }}>
            <Box>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <DialogHeader
                    title={productCopy.productName}
                    subTitle={productCopy.productDescription}
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControl
                    disabled={defaultPizzaSizeId && defaultPizzaSizeId > 0}
                    fullWidth
                  >
                    <InputLabel id="Pizza Size Selector">Size:</InputLabel>
                    <Select
                      labelId="Pizza Size Selector"
                      id="pizzaSize"
                      value={pizzaSizeId}
                      label="Size:"
                      onChange={handleSizeChange}
                    >
                      {defaults?.pizzaSizes
                        ? defaults.pizzaSizes.map((x, index) => {
                            const label =
                              defaultPizzaSizeId && defaultPizzaSizeId > 0
                                ? `${x.sizeName}`
                                : `${x.sizeName} ($${x.sizePriceX1.toFixed(
                                    2
                                  )})`;
                            return (
                              <MenuItem key={index} value={x.sizeId}>
                                {label}
                              </MenuItem>
                            );
                          })
                        : null}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel id="Pizza Crust Selector">Crust:</InputLabel>
                    <Select
                      labelId="Pizza Crust Selector"
                      id="crustId"
                      value={crustTypeId}
                      label="Crust:"
                      onChange={handleCrustChange}
                    >
                      {defaults?.pizzaCrusts && defaults?.pizzaCrusts.length
                        ? defaults.pizzaCrusts.map((x, index) => (
                            <MenuItem key={index} value={x?.modifierId}>
                              {`${x?.modifierName} ($${
                                x?.modifierCost.toFixed(2) || "0".toFixed(2)
                              })`}
                            </MenuItem>
                          ))
                        : null}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="note"
                    label="Notes"
                    multiline
                    onChange={(e) => setNote(e.target.value)}
                    rows={4}
                    fullWidth
                  />
                </Grid>
                {product.isCreateYourOwn != 1 ? (
                  <Grid
                    item
                    xs={12}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <ButtonGroup
                      variant="contained"
                      aria-label="Quantity counter"
                    >
                      <Button
                        sx={{ minWidth: "65px" }}
                        onClick={() => decreaseCounter()}
                        aria-label="decrease quantity"
                      >
                        -
                      </Button>
                      <TextField
                        id="quantity"
                        disabled={true}
                        type="number"
                        inputProps={{ style: { textAlign: "center" } }}
                        sx={{ textAlign: "center", width: "50px" }}
                        onChange={handleNumberCharge}
                        value={productCopy.quantity}
                      />
                      {/* <Button
                        aria-label={`Current quantity ${productCopy.quantity}`}
                        disabled
                      >
                        {productCopy.quantity}
                      </Button> */}
                      <Button
                        sx={{ minWidth: "65px" }}
                        onClick={() => increaseCounter()}
                        aria-label="increase quantity"
                      >
                        +
                      </Button>
                    </ButtonGroup>
                  </Grid>
                ) : null}
              </Grid>
            </Box>
            {customize ? (
              <PizzaModifierSelector
                product={productCopy}
                sizeId={pizzaSizeId}
                open={customize}
                onClose={() => setCustomize(false)}
                onSave={handleCustomizationSave}
              />
            ) : null}
          </DialogContent>
          <DialogActions
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                flexDirection: {
                  xs: "column",
                  sm: "column",
                  md: "row",
                  lg: "row",
                  xl: "row",
                },
              }}
            >
              <Button
                color="error"
                variant="contained"
                autoFocus
                onClick={onClose}
                sx={{ marginTop: "5px" }}
              >
                Cancel
              </Button>

              <Button
                color="success"
                variant="contained"
                onClick={() => setCustomize(true)}
                sx={{ marginTop: "5px" }}
              >
                Customize
              </Button>
              <Button
                variant="contained"
                autoFocus
                onClick={() => handleAddToCart()}
                sx={{ marginTop: "5px" }}
              >
                Add to cart
              </Button>
            </Box>
          </DialogActions>
        </>
      ) : null}
    </BootstrapDialog>
  );
};
